module.exports = __webpack_public_path__ + "6298ac8f5b4174e9a600a76af1174519.svg";